export const UberPaymentError = {
  QuoteIdMismatch: "QuoteIdMismatch",
  UnknownFailure: "UnknownFailure",
};

export type UberPaymentError =
  (typeof UberPaymentError)[keyof typeof UberPaymentError];
